import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21cde602&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&id=21cde602&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=21cde602&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cde602",
  null
  
)

export default component.exports